<template>
    <div>
        <v-container fluid v-if="users" class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Users</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                        color="info"
                        dark
                        class="mb-2"
                        :to="{name: 'user-create'}"

                >
                    <i class="fas fa-plus mr-2"></i> New User
                </v-btn>
            </div>

            <v-card>
                <v-card-title>

                    <v-spacer></v-spacer>

                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-card-subtitle>
                    <v-switch
                            v-model="trashed"
                            label="Show Deleted"
                            true-value="WITH"
                            false-value="WITHOUT"

                    />
                </v-card-subtitle>


                <v-data-table
                        :loading="this.$apollo.queries.users.loading"
                        :headers="headers"
                        :items="users.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="users.paginatorInfo.lastPage * pageCount"
                        :footer-props="{'items-per-page-options': [20, 40]}"
                >

                    <template v-slot:item.firstName="{ item }">

                        <router-link
                                :to="{name:'trainer-view', params:{id: item.id}}"
                        >{{item.firstName}} {{item.lastName}}</router-link>
                    </template>

                    <template v-slot:item.roles="{ item }">

                        <v-chip v-for="role in item.roles" :key="role.id">
                            {{role.displayName}}
                        </v-chip>
                    </template>
                    <template v-slot:item.avatar="{ item }">
                        <v-avatar color="indigo" size="32" class="mr-2" >
                            <v-img
                                    v-if="item.avatar"
                                    class="elevation-6"
                                    alt=""
                                    :src="item.avatar"
                            ></v-img>
                            <span class="white--text" v-if="!item.avatar">{{initials(item)}}</span>
                        </v-avatar>
                    </template>

                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import USERS_LIST from "../../graphql/Users/List.gql";

    export default {
        metaInfo: {
            title: 'users'
        },
        apollo: {
            users: {
                query: USERS_LIST,
                variables() {

                    let where = {AND: []}
                    if (this.search !== '') {
                        where.AND.push({
                            'OR': [
                                {column: 'FIRSTNAME', operator: 'LIKE', value: '%' + this.search + '%'},
                                {column: 'LASTNAME', operator: 'LIKE', value: '%' + this.search + '%'},
                            ]
                        })
                    }

                    let sortField = this.sortBy[0] ? this.sortBy[0] : 'TRAINER_FIRST'
                    let sortDirection = this.sortDesc[0] ? 'DESC' : 'ASC'

                    if (sortField === 'firstName') {
                        sortField = 'FIRSTNAME'
                    }

                    if (sortField === 'lastName') {
                        sortField = 'LASTNAME'
                    }

                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: sortField.toUpperCase(), order: sortDirection},
                        trashed: this.trashed,
                    }
                },
                update: data => data.users
            },
        },
        data() {
            return {
                search: '',
                page: 1,
                pageCount: 20,
                sortBy: ['firstName'],
                sortDesc: [false],
                trashed: 'WITHOUT',
                headers: [
                    {
                        text: 'Avatar',
                        align: 'start',
                        value: 'avatar',
                    },
                    {
                        text: 'Name',
                        align: 'start',
                        value: 'firstName',
                    },
                    {
                        text: 'Email',
                        align: 'start',
                        value: 'email',
                    },
                    {
                        text: 'Roles',
                        align: 'start',
                        value: 'roles',
                    },
                ],
            }
        },
        methods: {
            initials(user) {
                return user.firstName.charAt(0) + user.lastName.charAt(0)
            }
        }

    }
</script>
